import { render, staticRenderFns } from "./OtherEducation.vue?vue&type=template&id=dd5f2f1e"
import script from "./OtherEducation.vue?vue&type=script&lang=js"
export * from "./OtherEducation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports